<c11n-card [hasBorder]="true" [density]="cardDensity">
  <div class="input-beneficiary-card" cardBody>
    <!-- Header: "Beneficiary" with bottom border -->
    <div class="input-beneficiary-card__header-section">
      <h3 class="c11n-text-lg">{{ content.BENEFICIARY_CARD_HEADER }}</h3>
    </div>

    <!-- Type Selection (data-driven from config) -->
    <ng-container *ngIf="showTypeSelection">
      <div class="input-beneficiary-card__content-section">
        <p class="c11n-text-md">{{ content.BENEFICIARY_CHOOSE_OPTION }}</p>

        <c11n-radio-group [groupId]="'beneficiaryTypeOptions'" [variant]="'tiles'">
          <c11n-radio
            *ngFor="let option of typeOptions"
            class="bene-type-radio"
            [labelText]="option.labelText"
            [labelWeight]="'bold'"
            [descriptiveLabel]="option.description"
            (stateChange)="handleTypeSelection($event)"
          >
            <input
              c11nRadioInput
              [(ngModel)]="selectedBeneficiaryType"
              [id]="option.radioId"
              type="radio"
              name="beneficiary-type"
              [value]="option.type"
            />
          </c11n-radio>
        </c11n-radio-group>
      </div>

      <!-- Cancel link -->
      <div
        *ngIf="showCancelOnTypeSelection || mode === 'edit'"
        class="input-beneficiary-card__cancel-section"
      >
        <button
          c11n-link
          [variant]="'secondary-reinforced'"
          class="input-beneficiary-card__cancel-link"
          (click)="handleCancel()"
        >
          {{ content.BENEFICIARY_CANCEL }}
        </button>
      </div>
    </ng-container>

    <!-- Delegated Form (ngSwitch on selectedBeneficiaryType) -->
    <ng-container *ngIf="!showTypeSelection" [ngSwitch]="selectedBeneficiaryType">
      <ng-container *ngSwitchCase="BeneficiaryType.INDIVIDUAL_BY_NAME">
        <app-person-input-form
          [mode]="mode"
          [existingData]="existingData"
          [householdMembers]="householdMembers"
          [householdPeople]="householdPeople"
          [section]="section"
          [isSaving]="isSaving"
          [showSelectError]="showSelectError"
          [showChangeType]="true"
          (save)="save.emit($event)"
          (saveEdit)="saveEdit.emit($event)"
          (changeType)="handleChangeType()"
          (cancel)="handleCancel()"
        ></app-person-input-form>
      </ng-container>

      <ng-container *ngSwitchCase="BeneficiaryType.TRUST">
        <app-trust-input-form
          [mode]="mode"
          [existingData]="existingData"
          [trusts]="trusts"
          [settlors]="settlors"
          [section]="section"
          [isSaving]="isSaving"
          [showChangeType]="true"
          (save)="save.emit($event)"
          (saveEditTrust)="saveEditTrust.emit($event)"
          (changeType)="handleChangeType()"
          (cancel)="handleCancel()"
        ></app-trust-input-form>
      </ng-container>
    </ng-container>
  </div>
</c11n-card>
